export default __webpack_public_path__ + "static/media/recurring.70211a57.svg";